module.exports = __webpack_public_path__ + "19f9b2e27636647e49c1a1d04bf62348.pdf";